import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import { useNavigate } from "react-router-dom";
import { encrypt2 } from "../../../utils/encrypt";
import { RouteLinks } from "../../../routes/RouteLinks";
import Skeleton from "react-loading-skeleton";
import Icons from "../../../assets/icons/icons";
import {
  capitalizeFirstLetter,
  formatNumWithCommaNairaSymbol,
  lowerCaseWrap,
  trimLongString,
} from "../../../helper";
import { CSVLink } from "react-csv";
import {
  RavenInputField,
  RavenNumberFormat,
  RavenToolTip,
} from "@ravenpay/raven-bank-ui";
import "../../../styles/dashboard/terminals/PhysicalCardIndex.css";
import { getAllInsights, getAllInsightTerminals } from "../../../redux/insight";
import React, { useContext, useEffect, useState } from "react";
import ActionContext from "../../../context/ActionContext";
import BadgeComponent from "../../../fragments/badge/BadgeComponent";
import AllMerchantTerminals from "./AllMerchantTerminals";
import ListViewTerminals from "./AllPhysicalTerminalsIndex";
import useWindowSize from "../../../utils/UseWindowSize";
import ListViewPhysicalTerminals from "./AllPhysicalTerminalsIndex";
import ExportFragment from "../../../fragments/ExportFragment";
import PaginationFragment from "../../../fragments/PaginationFragment";
import PerPageComponent, {
  perPageList,
} from "../../../fragments/PerPageComponent";
import GridListViewSwitch from "../../../fragments/grid-list-switch/GridViewSwitch";
import TerminalCardComponent from "./common/TerminalCardComponent";
import {
  generalSearchFunctionality,
  VIEWSWITCHLIST,
} from "../../../utils/helpers";
import { debounce } from "lodash";
import Pagination from "../../../fragments/pagination";

interface ComponentProps {
  dontShowHeaders?: boolean;
}
const PhysicalTerminalsDisplay = () => {
  const size = useWindowSize();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const CsvHeader = [
    { label: "S/N", key: "num" },
    { label: "TERMINAL LABEL", key: "tid_label" },
    { label: "TERMINAL ID", key: "tid" },
    { label: "SERIAL NO", key: "serial" },
    { label: "BANK TRANSFER AMOUNT", key: "transfer_volume" },
    { label: "CARD TRANSFER AMOUNT", key: "card_volume" },
    { label: "TOTAL AMOUNT", key: "cal" },
    { label: "STATUS", key: "status" },
  ];
  const [all_terminals, setAllTerminals] = useState<any>({});
  const getDatesInRange = (daysAgo: number) => {
    var dates = [] as any;
    var currentDate = new Date();
    for (var i = 0; i < daysAgo; i++) {
      var date = new Date(currentDate);
      date.setDate(currentDate.getDate() - i);
      dates.push(date.toISOString().slice(0, 10)); // Format date as "YYYY-MM-DD"
    }
    const obj = {
      start: dates[0],
      end: dates[dates?.length - 1],
    };

    return obj;
  };
  const getStartAndEndDate = () => {
    let val;
    if (durationVal?.label === "All time") {
      const obj = {
        startDate: "",
        stopDate: "",
      };
      val = obj;
    }
    if (durationVal?.label === "Today") {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Months are zero-based
      const day = today.getDate();

      const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;
      const obj = {
        startDate: formattedDate,
        stopDate: formattedDate,
      };
      val = obj;
    }
    if (durationVal?.label === "Yesterday") {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Months are zero-based
      const day = today.getDate();

      const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + (Number(day) - 1) : Number(day) - 1
      }`;
      const obj = {
        startDate: formattedDate,
        stopDate: formattedDate,
      };
      val = obj;
    }
    if (
      durationVal?.label === "Last 30 Days" ||
      durationVal?.label === "Last 7 Days" ||
      durationVal?.label === "Last 14 Days"
    ) {
      // getDatesInRange(7);
      const obj = {
        stopDate: getDatesInRange(
          durationVal?.label === "Last 7 Days"
            ? 7
            : durationVal?.label === "Last 14 Days"
            ? 14
            : 30
        )?.start,
        startDate: getDatesInRange(
          durationVal?.label === "Last 7 Days"
            ? 7
            : durationVal?.label === "Last 14 Days"
            ? 14
            : 30
        )?.end,
      };
      val = obj;
    }
    if (
      durationVal?.label === "Specific Day" ||
      durationVal?.label === "Custom"
    ) {
      const obj = {
        startDate: dateRange?.startDate?.replaceAll("/", "-"),
        stopDate: dateRange?.endDate?.replaceAll("/", "-"),
      };
      val = obj;
    }

    return val;
  };
  const { loading, insights, insight_terminals, all_virtual_terminals, all_device_request } =
    useSelector((state: RootState) => state.insights);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [durationVal, setDurationVal] = useState<any>({
    label: "All time",
    value: " ",
  });
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [currentPageVal, setCurrentPageVal] = useState(1);
  const actionCtx = useContext(ActionContext);

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
      getAllInsightsFunc();
      getAllInsightsTerminalsFunc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCtx?.configDetails, durationVal, dateRange]);

  const getAllInsightsFunc = async () => {
    const obj = {
      startDate: getStartAndEndDate()?.startDate,
      endDate: getStartAndEndDate()?.stopDate,
    };
    // console.log(obj);

    const data = await dispatch(getAllInsights(obj as any) as any);
    if (
      durationVal?.label === "All time" &&
      data?.payload?.status === "success"
    ) {
      const lengthVal = data?.payload?.data?.data?.terminals;
      // if (lengthVal?.length > 0) {
      //   setNoTableContent(false);
      // } else {
      //   setNoTableContent(true);
      // }
    }
  };

  const formatExportData = (data: any) => {
    const list = data?.map((chi: any, idx: any) => {
      return {
        num: idx < 10 ? `0${idx + 1}` : idx + 1,
        tid_label: capitalizeFirstLetter(chi?.tid_label),
        tid: chi?.tid,
        serial: chi?.tid_label,
        transfer_volume: formatNumWithCommaNairaSymbol(
          String(chi?.transfer_volume)
        ),
        card_volume: formatNumWithCommaNairaSymbol(String(chi?.card_volume)),
        cal: formatNumWithCommaNairaSymbol(
          String(Number(chi?.transfer_volume) + Number(chi?.card_volume))
        ),
        status: "success",
      };
    });
    return list;
  };

  const getAllInsightsTerminalsFunc = async () => {
    dispatch(getAllInsightTerminals({} as any) as any);
  };

  useEffect(() => {
    if (insight_terminals?.data?.length > 0) {
      paginateArray(
        insight_terminals?.data,
        actionCtx?.perPageGlobalVal?.value,
        currentPage
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    insight_terminals,
    currentPage,
    actionCtx.perPageGlobalVal,
    actionCtx?.configDetails,
  ]);

  interface PaginationResult<T> {
    currentPage: number;
    perPageArrays: T[][];
    totalPages: number;
    nextPage: number | null;
    prevPage: number | null;
    arrayToShow: any;
    startIndex: number;
    endIndex: number;
  }

  function paginateArray<T>(
    array: T[],
    pageSize: number,
    currentPage: number
  ): PaginationResult<T> {
    const perPageArrays: T[][] = [];
    const totalPages = Math.ceil(array.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, array.length);

    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * pageSize;
      const endIndex = Math.min(startIndex + pageSize, array.length);
      perPageArrays.push(array.slice(startIndex, endIndex));
    }

    const obj = {
      currentPage,
      perPageArrays,
      totalPages,
      startIndex: startIndex + 1,
      endIndex,
      arrayToShow: perPageArrays[currentPage - 1],
      nextPage: currentPage < totalPages ? currentPage + 1 : null,
      prevPage: currentPage > 1 ? currentPage - 1 : null,
    };
    setAllTerminals(obj);
    return obj;
  }

  const handleSearch = debounce(async (param: any) => {
    const newList = generalSearchFunctionality(
      param,
      ["serial", "tid", "tid_label"],
      insight_terminals?.data
    );
    paginateArray(newList, actionCtx?.perPageGlobalVal?.value, currentPage);
  }, 50);

  const switchNum = 10;
  const [viewMode, setViewMode] = useState(VIEWSWITCHLIST[0]);
  const ActualArrayList = insight_terminals?.data;
  useEffect(() => {
    if (ActualArrayList?.length > switchNum && Number(size?.width) > 900) {
      actionCtx?.setViewListMode(VIEWSWITCHLIST[1]);
      setViewMode(VIEWSWITCHLIST[1]);
    } else {
      setViewMode(VIEWSWITCHLIST[0]);
      actionCtx?.setViewListMode(VIEWSWITCHLIST[0]);
    }
  }, [size]);

  return (
    <AllMerchantTerminals
      loading={loading}
      noContent={
        Object?.keys(all_virtual_terminals)?.length < 1 &&
        Object?.keys(insight_terminals)?.length < 1 &&
        Object?.keys(all_device_request)?.length < 1 
      }
    >
      {/* list and grid view start */}
      <div
        onClick={() => {
          console.log(insight_terminals);
        }}
        className="physical-card-list-grid-general-wrapper-index-box"
      >
        <div className="search-export-filter-box">
          {/* search box start */}
          <form
            action=""
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="search-box"
            autoComplete="off"
          >
            <RavenInputField
              color="green-light"
              type="search"
              placeholder="Search Terminals"
              value={search}
              onChange={(e: any) => {
                handleSearch(e.target.value);
                setSearch(e.target.value);
              }}
            />
          </form>
          {/* search box end */}
          {/* filter-export pagination box start */}
          <div className="filter-export-pagination-box">
            {/* <FilterFragment page="all-transactions" /> */}

            <CSVLink
              // ref={download}

              className="export-table-content-box tooltip-hover-wrap grey-bg"
              filename={"All Terminals.csv"}
              data={formatExportData(ActualArrayList) || ""}
              headers={CsvHeader}
            >
              {" "}
              <RavenToolTip
                color="deep-green-light"
                text="Export Table Content"
                position={`left`}
              />
              <ExportFragment
                onClick={() => {
                  // setShowModal((prev) => {
                  //   return { ...prev, export: true };
                  // });
                }}
              />
            </CSVLink>

            <Pagination
              currentPage={currentPage}
              itemsPerPage={actionCtx?.perPageGlobalVal?.value || "1"}
              totalItems={insight_terminals?.data?.length || 0}
              onPageChange={(param: number) => {
                setCurrentPage(param);
              }}
              loading={loading}
              // canHide
            />
            {ActualArrayList?.length > perPageList[0]?.value && (
              <PerPageComponent />
            )}
            {Number(size?.width) > 900 && (
              <GridListViewSwitch
                onManualSwitch={(param) => {
                  setViewMode(param);
                }}
              />
            )}
          </div>
          {/* filter-export pagination box end */}
        </div>

        <div
          className={`physical-card-general-display-box ${
            actionCtx?.viewListMode?.value === VIEWSWITCHLIST[0]?.value &&
            ActualArrayList?.length < 5
              ? "physical-card-general-display-box-flex"
              : ""
          }`}
        >
          {actionCtx?.viewListMode?.value === VIEWSWITCHLIST[1]?.value ? (
            <>
              <ListViewPhysicalTerminals list={ActualArrayList} />
            </>
          ) : (
            <>
              {" "}
              {ActualArrayList?.map((chi: any, idx: any) => {
                const { tid_label, serial, volume, tid, status } = chi || {};
                return (
                  <TerminalCardComponent
                    details={chi}
                    key={idx}
                    status={status}
                    loading={loading}
                    serial={serial}
                    tid={tid}
                    tid_label={tid_label}
                  />
                );
              })}
            </>
          )}
        </div>
      </div>
      {/* list and grid view end */}
    </AllMerchantTerminals>
  );
};

export default PhysicalTerminalsDisplay;
